import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-block-header',
    templateUrl: './block-header.component.html',
    styleUrls: ['./block-header.component.scss']
})
export class BlockHeaderComponent {
    @Input() header: string;
    @Input() arrows = false;

    @Output() next: EventEmitter<any> = new EventEmitter();
    @Output() prev: EventEmitter<any> = new EventEmitter();

    constructor() { }

}
